var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 175,
    viewBox: "0 0 1440 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1255_19353)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 175,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1255_19353)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.2502,
    cy: 33.2502,
    r: 138.5,
    transform: "rotate(-40.4459 87.2502 33.2502)",
    fill: "#0017E7",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1255_19353)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 872.536,
    cy: 109.699,
    rx: 88.6852,
    ry: 388.503,
    transform: "rotate(-59.8736 872.536 109.699)",
    fill: "#0017E7",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1255_19353)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 552.712,
    cy: 194.954,
    rx: 402.236,
    ry: 77.8988,
    transform: "rotate(27.5222 552.712 194.954)",
    fill: "#E700C8",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1255_19353)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 305.788,
    cy: 138.5,
    rx: 305.788,
    ry: 138.5,
    transform: "matrix(-0.761019 -0.64873 -0.64873 0.761019 1702.12 134.748)",
    fill: "#0017E7",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1255_19353)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 138.5,
    r: 138.5,
    transform: "matrix(-0.761019 -0.64873 -0.64873 0.761019 1252.5 109.698)",
    fill: "#E700C8",
    fillOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1255_19353",
    x: -251.253,
    y: -305.253,
    width: 677.005,
    height: 677.006,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_1255_19353"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1255_19353",
    x: 333.538,
    y: -299.896,
    width: 1078,
    height: 819.188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_1255_19353"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1255_19353",
    x: -5.84308,
    y: -203.394,
    width: 1117.11,
    height: 796.694,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_1255_19353"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1255_19353",
    x: 930.039,
    y: -382.906,
    width: 899.042,
    height: 849.362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_1255_19353"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1255_19353",
    x: 718.747,
    y: -213.253,
    width: 677.005,
    height: 677.006,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_1255_19353"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1255_19353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 175,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgProfile);
export default __webpack_public_path__ + "static/media/bg_profile.316cde05eac6d249dd1cf899d2e8363e.svg";
export { ForwardRef as ReactComponent };